import { ClubCrest } from './ClubCrest'

interface VersusSide {
  name: string
  isPlayer?: boolean
}

interface VersusBannerProps {
  home: VersusSide
  away: VersusSide
  score?: [number, number]
  label?: string
  tone?: 'upcoming' | 'won' | 'lost'
  crestSize?: number
}

// TV matchup banner: two angled halves with crests and a gold rhombus
// holding "VS" (upcoming) or the final score.
export function VersusBanner({ home, away, score, label, tone = 'upcoming', crestSize = 34 }: VersusBannerProps) {
  const toneClass = tone === 'upcoming' ? '' : ` tone-${tone}`
  return (
    <div className={`versus-banner tx-glass-sheen${toneClass}${label ? ' has-label' : ''}`}>
      <div className="versus-side home">
        <ClubCrest name={home.name} size={crestSize} />
        <span className={`versus-name${home.isPlayer ? ' me' : ''}`}>{home.name}</span>
      </div>
      <div className="versus-center">
        {score ? (
          <span className="versus-score">
            {score[0]} – {score[1]}
          </span>
        ) : (
          <span className="versus-vs">VS</span>
        )}
      </div>
      <div className="versus-side away">
        <ClubCrest name={away.name} size={crestSize} />
        <span className={`versus-name${away.isPlayer ? ' me' : ''}`}>{away.name}</span>
      </div>
      {label && <div className="versus-label">{label}</div>}
    </div>
  )
}
